import { Box, brandMark, webPalette } from '@munifocus/ui';

interface BrandMarkProps {
  withWord?: boolean;
  /** 'dark' for use on the deep-green header/footer, 'light' for use on white/cream surfaces. */
  variant?: 'dark' | 'light';
  /** Smaller on phones, so the header bar keeps room for its menu button. */
  compact?: boolean;
}

export function BrandMark({ withWord = true, variant = 'dark', compact = false }: BrandMarkProps) {
  const onDark = variant === 'dark';
  const outerStroke = onDark ? webPalette.borderOnDarkStrong : webPalette.borderOnLight;
  const innerStroke = onDark ? brandMark.onDark : brandMark.onLight;
  const dotFill = onDark ? brandMark.onDark : brandMark.onLight;
  const wordColor = onDark ? webPalette.onDark : webPalette.ink;
  const accentColor = onDark ? brandMark.onDark : brandMark.onLight;
  const tldColor = onDark ? webPalette.onDarkGhost : webPalette.mutedSoft;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: compact ? { xs: '8px', sm: '11px' } : '11px',
      }}
    >
      <Box
        component="svg"
        viewBox="0 0 48 32"
        fill="none"
        sx={{
          width: compact ? { xs: 30, sm: 34 } : 34,
          height: compact ? { xs: 21, sm: 24 } : 24,
          flex: 'none',
        }}
      >
        <path
          d="M5 25 A19 19 0 0 1 43 25"
          stroke={outerStroke}
          strokeWidth={3}
          strokeLinecap="round"
        />
        <path
          d="M13 25 A11 11 0 0 1 35 25"
          stroke={innerStroke}
          strokeWidth={3}
          strokeLinecap="round"
        />
        <circle cx={24} cy={25} r={3.6} fill={dotFill} />
      </Box>
      {withWord ? (
        <Box
          component="span"
          sx={{
            fontWeight: 700,
            fontSize: compact ? { xs: 18, sm: 21 } : 21,
            letterSpacing: '-0.01em',
            color: wordColor,
          }}
        >
          Muni
          <Box component="span" sx={{ color: accentColor }}>
            Focus
          </Box>
          <Box component="span" sx={{ color: tldColor, fontWeight: 600 }}>
            .com
          </Box>
        </Box>
      ) : null}
    </Box>
  );
}
